export const trackingSteps = [
  {
    id: 'placed',
    label: 'Order Placed',
    description: 'Your order has been confirmed',
    icon: 'ri-file-list-3-line',
    time: '2:30 PM',
  },
  {
    id: 'preparing',
    label: 'Preparing Order',
    description: 'Partner store is packing your beverages',
    icon: 'ri-store-2-line',
    time: '2:35 PM',
  },
  {
    id: 'on_way',
    label: 'Out for Delivery',
    description: 'Your rider is heading your way',
    icon: 'ri-motorbike-line',
    time: '2:50 PM',
  },
  {
    id: 'delivered',
    label: 'Delivered',
    description: 'Enjoy your beverages!',
    icon: 'ri-checkbox-circle-line',
    time: null,
  },
];

export const sampleOrder = {
  id: 'SDG-20847',
  status: 'on_way',
  rider: {
    name: 'Marcus Johnson',
    phone: '+592-600-1234',
    rating: 4.9,
    avatar: 'https://public.readdy.ai/ai/img_res/25b8ec62d561e2b7af413b0e33c58e27.jpg',
  },
  eta: '8 min',
  items: [
    { name: 'Banks Beer x6', price: 4800 },
    { name: 'El Dorado Rum 750ml', price: 4500 },
  ],
  total: 9700,
  address: '45 Camp Street, Georgetown',
};

export const paymentMethods = [
  {
    id: 'card',
    label: 'Credit / Debit Card',
    icon: 'ri-bank-card-line',
    description: 'Visa, Mastercard accepted',
    popular: true,
  },
  {
    id: 'cash',
    label: 'Cash on Delivery',
    icon: 'ri-money-dollar-circle-line',
    description: 'Pay when your order arrives',
    popular: false,
  },
];
